<template>
    <div class="main">
        <div class="container">
            <p style="height: 50px;"></p>
            <p class="has-text-centered	">
                <router-link :to="{ path: '/' }"><img src="/assets/l_1.png" /></router-link>
            </p>
            <p style="height: 10px;"></p>
            <p class="has-text-centered	">
                <router-link :to="{ path: '/' }"><img src="/assets/l_2.png" /></router-link>
            </p>
            <p style="height: 50px;"></p>
            <div class=" is-clearfix   has-background-white columns" style="padding: 10px; border-radius: 10px;">
                <router-link :to="{ path: '/' }">
                    <button class="button" v-show="$route.path != '/plist'" type="button">
                        <span class="icon">
                            <i class="fa fa-home"></i>
                        </span>
                        <span>首页</span>
                    </button>
                </router-link>
                <div class="column"></div>
                <div class=" field is-horizontal " v-show="showSearch">
                    <div class="field-body">
                        <div class="field">
                            <p class="control is-expanded has-icons-left">
                                <input class="input  is-success" type="text" v-model="s_sno" placeholder="报名序号" />
                                <span class="icon is-small is-left">
                                    <i class="fa fa-tag"></i>
                                </span>
                            </p>
                        </div>
                        <div class="field is-grouped">
                            <p class="control is-expanded has-icons-left ">
                                <input class="input is-success" type="text" v-model="s_idno" placeholder="身份证号" />
                                <span class="icon is-small is-left">
                                    <i class="fa fa-id-card"></i>
                                </span>
                            </p>
                            <p class="control">
                                <button class="button is-primary" type="button" @click="doSearch">
                                    查询报名状态
                                </button>
                            </p>
                            <p class="control">
                                <button class="button is-danger" type="button" @click="doGetBMXH">
                                    找回报名序号
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <router-view />
            <!-- <p class=" is-clearfix " style="height: 20px;"></p> -->
            <div class="is-clearfix has-background-white columns" style="margin-top: 25px; padding: 20px 0 0 0; border-radius: 10px;">
                <div class="column"></div>
                <div class="content has-text-centered ">
                    <p>
                        版权所有 © 台前县人力资源和社会保障局主办
                    </p>
                    <p class="is-size-7">
                        报名咨询电话：0393-8631128
                        <!-- 技术支持：
                        <a href="http://www.hnlex.com/" target="_blank">乐信网络</a> -->
                    </p>
                    <!-- <div style="height: 108px;">
                        <img src="/assets/gzh.jpg" alt="" style="width:108px; height:108px; margin-right: 30px;" />
                        <img src="/assets/xcx.jpg" alt="" style="width:108px; height:108px;" />
                    </div> -->
                </div>
                <div class="column"></div>
            </div>
        </div>
        <!-- <div id="adbox" ref="adbox" v-show="showAdbox" @mouseenter="enterbox" @mouseleave="leavebox">
            <a href="javascript:;">
                <img src="/assets/how-print.png" />
            </a>
            <b @click="closebox"><img src="/assets/close.png" class="close" alt="" /></b>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'RecIndex',
    data() {
        return {
            s_idno: '',
            s_sno: ''
            // x: 300,
            // y: 300,
            // xin: true,
            // yin: true,
            // step: 1,
            // delay: 10
            // itl: null,
            // showAdbox: false
        }
    },
    // beforeRouteEnter(to, from, next) {
    //     next(vm => {
    //         // eslint-disable-line no-unused-vars
    //         vm.routeEnterShowAdbox() // eslint-disable-line no-unused-vars
    //     })
    // },
    // beforeRouteLeave(to, from, next) {
    //     next(vm => {}) // eslint-disable-line no-unused-vars
    //     clearInterval(this.itl)
    // },
    computed: {
        showSearch() {
            return this.$route.name === 'RecPlanList' || this.$route.name === 'RecPostList'
        }
    },

    methods: {
        // closebox() {
        //     this.showAdbox = false
        //     clearInterval(this.itl)
        // },
        // leavebox() {
        //     if (this.showAdbox == false) {
        //         clearInterval(this.itl)
        //     } else {
        //         this.itl = setInterval(this.movebox, this.delay)
        //     }
        // },
        // enterbox() {
        //     clearInterval(this.itl)
        // },
        // movebox() {
        //     var L = 0
        //     var T = 0
        //     var R = document.documentElement.clientWidth - this.$refs.adbox.offsetWidth //浏览器显示宽度-adbox宽度，不随滚动条变化而变化
        //     var B = document.documentElement.clientHeight - this.$refs.adbox.offsetHeight //浏览器显示高度-adbox高度，不随滚动条变化而变化
        //     this.$refs.adbox.style.left = this.x + document.documentElement.scrollLeft + 'px' //adbox初始左+滚动条最左端到浏览器最左端的距离
        //     this.$refs.adbox.style.top = this.y + document.documentElement.scrollTop + 'px' //adbox初始高+滚动条顶端到浏览器顶端的距离
        //     this.x = this.x + this.step * (this.xin ? 1 : -1)
        //     if (this.x < L) {
        //         this.xin = true
        //         this.x = L
        //     }
        //     if (this.x > R) {
        //         this.xin = false
        //         this.x = R
        //     }
        //     this.y = this.y + this.step * (this.yin ? 1 : -1)
        //     if (this.y < T) {
        //         this.yin = true
        //         this.y = T
        //     }
        //     if (this.y > B) {
        //         this.yin = false
        //         this.y = B
        //     }
        // },
        // routeEnterShowAdbox() {
        //     this.itl = setInterval(this.movebox, this.delay)
        // },
        alert(info) {
            this.$message({
                title: '提示',
                content: info,
                mode: 'alert'
            })
        },
        doSearch() {
            if (!this.s_sno) {
                this.alert('请填写报名序号')
                return
            }
            if (!this.s_idno) {
                this.alert('请填写身份证号')
                return
            }

            this.$router.push({
                name: 'RecRegResult',
                query: {
                    sno: this.s_sno,
                    idno: this.s_idno
                }
            })
        },
        doGetBMXH() {
            this.$router.push({
                name: 'getBMXH'
            })
        }
    }
}
</script>

<style scoped>
.main ::selection {
    color: rgba(255, 255, 255, 0.8);
    background-color: #fe7300;
}
.main {
    background-image: url(/assets/bg.jpg);
    background-repeat: repeat;
    background-attachment: fixed;
    margin: 0 auto;
    min-height: 100vh;
}

#adbox {
    width: 200px;
    height: 200px;
    position: absolute;
    z-index: 999;
}

#adbox img {
    border: none;
}

#adbox b {
    /* position: absolute;
    right: 5px;
    top: 0; */
    cursor: pointer;
    text-align: center;
    display: flex;
    justify-content: center;
}

.close {
    width: 30px;
    height: 30px;
}
</style>
